module.exports = __webpack_public_path__ + "img/selected.f83d4d92.svg";